export const themeConfig = {
  defaultMode: 'light' as const,
  modeStorageKey: 'lta-activators-theme-mode',
  classesPrefix: 'lta',
};
